import api from "api";

const partnerOnboarding = {
    // Não é pública: logado, o token vai junto e a API usa a conta (e o e-mail) dele.
    create: (formData) => {
        return api(false).post('/partner-onboardings', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    validate: (formData) => {
        return api(false, true).post('/partner-onboardings/validate', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
};

export default partnerOnboarding;
